import focusedInboxRollupStore from '../store/store';
import FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';
import InboxViewType from 'owa-service/lib/contract/InboxViewType';
import userConfigurationDictionaryEntry from 'owa-service/lib/factory/userConfigurationDictionaryEntry';
import userConfigurationDictionaryObject from 'owa-service/lib/factory/userConfigurationDictionaryObject';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import updateUserConfiguration from 'owa-session-store/lib/services/updateUserConfiguration';
import { createLegacyActionWithDatapoint } from 'owa-analytics-actions';
import datapoints from '../datapoints';
import { ActionSource } from 'owa-mail-store';

/**
 * Update last visit timestamp for selected view and reset rollup data
 */
export default createLegacyActionWithDatapoint(
    'updateWatermarkAndResetRollup',
    datapoints.resetFocusedOtherRollup
)(function updateWatermarkAndResetRollup(
    focusedViewFilter: FocusedViewFilter,
    actionSource: ActionSource
) {
    resetRollupData();
    updateFolderViewWatermark(focusedViewFilter);
});

/**
 * Update folder view watermark for focused/other folders
 * @param focusedViewFilter for which watermark is to be updated
 */
function updateFolderViewWatermark(focusedViewFilter: FocusedViewFilter) {
    const viewStateConfiguration = getUserConfiguration().ViewStateConfiguration;
    const currentTime = new Date(Date.now()).toUTCString();

    if (focusedViewFilter == FocusedViewFilter.Focused) {
        getUserConfiguration().ViewStateConfiguration.FocusedViewWatermark = currentTime;

        updateUserConfiguration('OWA.ViewStateConfiguration', [
            userConfigurationDictionaryEntry({
                DictionaryKey: userConfigurationDictionaryObject({
                    Type: 'String',
                    Value: ['FocusedViewWatermark'],
                }),
                DictionaryValue: userConfigurationDictionaryObject({
                    Type: 'String',
                    Value: [viewStateConfiguration.FocusedViewWatermark],
                }),
            }),
        ]);
    } else if (focusedViewFilter == FocusedViewFilter.Other) {
        getUserConfiguration().ViewStateConfiguration.ClutterViewWatermark = currentTime;

        updateUserConfiguration('OWA.ViewStateConfiguration', [
            userConfigurationDictionaryEntry({
                DictionaryKey: userConfigurationDictionaryObject({
                    Type: 'String',
                    Value: ['ClutterViewWatermark'],
                }),
                DictionaryValue: userConfigurationDictionaryObject({
                    Type: 'String',
                    Value: [viewStateConfiguration.ClutterViewWatermark],
                }),
            }),
        ]);
    }
}

/**
 * Reset rollup data in store
 */
function resetRollupData() {
    focusedInboxRollupStore.uniqueSenders = null;
    focusedInboxRollupStore.unseenCountToDisplay = null;
    focusedInboxRollupStore.viewType = InboxViewType.Invalid;
}
